import { render, staticRenderFns } from "./GeneralPDV.vue?vue&type=template&id=1d018571&scoped=true"
import script from "./GeneralPDV.vue?vue&type=script&lang=js"
export * from "./GeneralPDV.vue?vue&type=script&lang=js"
import style0 from "./GeneralPDV.vue?vue&type=style&index=0&id=1d018571&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d018571",
  null
  
)

export default component.exports